import FormikRadioButtons from 'src/components/formik-radio-buttons';
import React from 'react';

const SexInput = () => (
  <FormikRadioButtons
    name="sex"
    options={[
      {value: 'F', label: 'Female'},
      {value: 'M', label: 'Male'},
      {value: 'Prefer Not to Answer', label: 'Prefer not to answer'},
    ]}
    legendText="What sex were you assigned at birth?"
  />
);

export default SexInput;
